(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jools-mobile-experience"]) return;
  try {
    
  if (!customElements.get('jools-experience')) {
    customElements.define('jools-experience', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const opts = { signal: this.controller.signal };
        this.searchDialog = this.querySelector('.jools-search-dialog');
        this.detailDialog = this.querySelector('.jools-detail-dialog');
        this.input = this.querySelector('#JoolsSearchInput');
        this.results = this.querySelector('#JoolsSearchSuggestions');
        this.empty = this.querySelector('.jools-search-empty');
        this.status = this.querySelector('.jools-search-status');
        this.searchForm = this.querySelector('.jools-search-form');
        document.addEventListener('click', e => {
          const opener = e.target.closest('[data-jools-search-open]');
          if (opener && !e.ctrlKey && !e.metaKey && !e.shiftKey) { e.preventDefault(); this.openDialog(this.searchDialog, opener); this.input.focus(); }
          const close = e.target.closest('[data-jools-close]');
          if (close && this.contains(close)) close.closest('dialog').close();
          const sizeGuide = e.target.closest('[data-jools-size-guide]');
          if (sizeGuide && this.querySelector('#JoolsSizeGuide')?.content.textContent.trim()) {
            e.preventDefault();
            this.detailDialog.querySelector('h2').textContent = sizeGuide.textContent.trim();
            this.detailDialog.querySelector('.jools-detail-content').replaceChildren(this.querySelector('#JoolsSizeGuide').content.cloneNode(true));
            this.openDialog(this.detailDialog,sizeGuide);
          }
          const summary = e.target.closest('.jools-page-product .product__info-container details > summary');
          if (summary) {
            e.preventDefault();
            const source = summary.parentElement.querySelector('.accordion__content, .rte');
            if (!source) return;
            this.detailDialog.querySelector('h2').textContent = summary.textContent.trim();
            const content = this.detailDialog.querySelector('.jools-detail-content');
            content.replaceChildren(...Array.from(source.childNodes).map(node => node.cloneNode(true)));
            content.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
            this.openDialog(this.detailDialog, summary);
          }
        }, opts);
        this.querySelectorAll('dialog').forEach(dialog => {
          dialog.addEventListener('close', () => { if(this.querySelector('dialog[open]')) return; document.body.classList.remove('jools-dialog-open'); this.returnFocus?.focus(); }, opts);
          dialog.addEventListener('click', e => { if (e.target === dialog) { const r = dialog.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close(); } }, opts);
        });
        this.input.addEventListener('input', () => this.queueSearch(), opts);
        this.searchForm.addEventListener('reset', () => { requestAnimationFrame(() => { this.queueSearch(); this.input.focus(); }); }, opts);
        this.searchForm.addEventListener('submit', e => { if (!this.input.value.trim()) { e.preventDefault(); this.input.focus(); } }, opts);
        this.bindProduct(opts);
        this.bindGallery(opts);
        this.bindCart();
        this.bindFavorites(opts);
        const keyboard = () => document.body.classList.toggle('jools-keyboard-open', !!window.visualViewport && window.innerHeight - window.visualViewport.height > 180 && /INPUT|TEXTAREA|SELECT/.test(document.activeElement?.tagName));
        window.visualViewport?.addEventListener('resize', keyboard, opts);
        document.addEventListener('focusout', () => document.body.classList.remove('jools-keyboard-open'), opts);
      }

      bindFavorites(opts) {
        this.favDialog=this.querySelector('.jools-favorites-dialog');
        this.favGrid=this.querySelector('.jools-favorites-grid');
        this.favStatus=this.querySelector('.jools-favorites-status');
        this.favRetry=this.querySelector('.jools-favorites-retry');
        this.favKey='jools-favorites-v1';
        const heartTemplate=this.querySelector('#JoolsProductHeart');
        const gallery=document.querySelector('product-info .product__media-wrapper');
        if(heartTemplate&&gallery&&!gallery.querySelector('.jools-product-heart')){
          gallery.classList.add('jools-heart-gallery');
          gallery.append(heartTemplate.content.cloneNode(true));
          const zoom=this.querySelector('.jools-gallery-dialog');
          if(zoom)zoom.append(heartTemplate.content.cloneNode(true));
        }
        this.readFavorites=()=>{try {const values=JSON.parse(localStorage.getItem(this.favKey)||'[]');return new Set(Array.isArray(values)?values.filter(h=>typeof h==='string'&&/^[a-z0-9-]+$/.test(h)).slice(0,100):[]);}catch{return new Set();}};
        this.favorites=this.readFavorites();
        this.syncFavorites=()=>{
          document.querySelectorAll('[data-jools-favorite]').forEach(b=>{
            const active=this.favorites.has(b.dataset.joolsFavorite);
            b.setAttribute('aria-pressed',String(active));
            b.setAttribute('aria-label',(active?this.favDialog.dataset.remove:this.favDialog.dataset.save)+': '+b.dataset.title);
          });
          this.querySelectorAll('[data-jools-favorites-count]').forEach(e=>{const value=String(this.favorites.size);if(e.textContent!==value)e.textContent=value;});
        };
        document.addEventListener('click',e=>{
          const toggle=e.target.closest('[data-jools-favorite]');
          if(toggle){
            e.preventDefault();e.stopPropagation();
            const handle=toggle.dataset.joolsFavorite;
            const saved=this.favorites.has(handle);
            if(!saved&&this.favorites.size>=100){this.favoriteToast(this.favDialog.dataset.limit);return;}
            const next=new Set(this.favorites);
            if(saved)next.delete(handle);else next.add(handle);
            try{localStorage.setItem(this.favKey,JSON.stringify([...next]));}catch{this.favoriteToast(this.favDialog.dataset.storageError);return;}
            this.favorites=next;this.syncFavorites();
            this.favoriteToast(saved?this.favDialog.dataset.removed:this.favDialog.dataset.saved);
            if(saved&&this.favDialog.open){
              const item=toggle.closest('[data-favorite-item]');
              const focus=item?.nextElementSibling?.querySelector('button')||item?.previousElementSibling?.querySelector('button')||this.favDialog.querySelector('[data-jools-close]');
              item?.remove();focus?.focus({preventScroll:true});
              if(!this.favorites.size)this.favStatus.textContent=this.favDialog.dataset.empty;
            }
          }
          const opener=e.target.closest('[data-jools-favorites-open]');
          if(opener){e.preventDefault();this.searchDialog.close();this.openDialog(this.favDialog,opener);this.renderFavorites();}
        },opts);
        this.favRetry.addEventListener('click',()=>this.renderFavorites(),opts);
        this.favDialog.addEventListener('close',()=>this.favAbort?.abort(),opts);
        window.addEventListener('storage',e=>{if(e.key===this.favKey){this.favorites=this.readFavorites();this.syncFavorites();if(this.favDialog.open)this.renderFavorites();}},opts);
        this.favObserver=new MutationObserver(records=>{if(records.some(r=>r.addedNodes.length))this.syncFavorites();});
        this.favObserver.observe(document.body,{childList:true,subtree:true});
        this.syncFavorites();
      }
      favoriteToast(message) {
        const toast=this.querySelector('.jools-favorites-toast');
        toast.textContent=message;toast.hidden=false;
        clearTimeout(this.favTimer);this.favTimer=setTimeout(()=>{toast.hidden=true;},2500);
      }
      async renderFavorites() {
        this.favAbort?.abort();this.favAbort=new AbortController();
        const signal=this.favAbort.signal;
        this.favGrid.replaceChildren();this.favRetry.hidden=true;
        this.favStatus.textContent=this.favorites.size?this.favDialog.dataset.loading:this.favDialog.dataset.empty;
        const handles=[...this.favorites].reverse();let failed=0;
        for(let start=0;start<handles.length;start+=4){
          const items=await Promise.all(handles.slice(start,start+4).map(async handle=>{
            try{
              const root=this.favDialog.dataset.root.replace(/\/$/,'');
              const url=new URL(root+'/products/'+encodeURIComponent(handle),location.origin);
              url.searchParams.set('section_id','jools-favorite-card');
              const response=await fetch(url,{signal});
              if(!response.ok)throw new Error('Unavailable');
              const doc=new DOMParser().parseFromString(await response.text(),'text/html');
              const card=doc.querySelector('[data-favorite-item]');
              if(!card)throw new Error('Unavailable');
              return this.favorites.has(handle)?card:null;
            }catch(e){if(e.name!=='AbortError')failed++;return null;}
          }));
          if(signal.aborted)return;
          this.favGrid.append(...items.filter(Boolean));this.syncFavorites();
        }
        this.favStatus.textContent=failed?this.favDialog.dataset.error:(!this.favorites.size?this.favDialog.dataset.empty:'');
        this.favRetry.hidden=!failed;
      }

      openDialog(dialog, opener) {
        if (dialog.open) return;
        this.returnFocus = opener;
        dialog.showModal();
        document.body.classList.add('jools-dialog-open');
      }
      queueSearch() {
        clearTimeout(this.timer);
        this.searchAbort?.abort();
        const query = this.input.value.trim();
        this.querySelector('.jools-clear').hidden = !query;
        this.empty.hidden = !!query;
        this.results.replaceChildren();
        this.status.textContent = query ? this.dataset.loading : '';
        this.results.removeAttribute('aria-busy');
        if (!query) return;
        this.timer = setTimeout(() => this.search(query), 250);
      }
      async search(query) {
        this.searchAbort = new AbortController();
        this.results.setAttribute('aria-busy','true');
        try {
          const url = new URL(this.dataset.suggestUrl, location.origin);
          url.searchParams.set('q', query);
          url.searchParams.set('resources[type]', 'query,product,collection');
          url.searchParams.set('resources[limit]', '6');
          url.searchParams.set('section_id', 'jools-search-results');
          const response = await fetch(url, {signal:this.searchAbort.signal});
          if (!response.ok) throw new Error('search');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('[data-jools-suggestions]');
          if (!html) throw new Error('search');
          if (this.input.value.trim() !== query) return;
          this.results.replaceChildren(html);
          this.status.textContent = this.dataset.ready;
        } catch(error) {
          if (error.name !== 'AbortError') this.status.textContent = this.dataset.error;
        } finally { if (this.input.value.trim() === query) this.results.removeAttribute('aria-busy'); }
      }
      bindGallery(opts) {
        const product = this.product;
        const dialog = this.querySelector('.jools-gallery-dialog');
        if (!product || !dialog) return;
        const thumbs = Array.from(dialog.querySelectorAll('[data-gallery-id]'));
        const image = dialog.querySelector('.jools-gallery-image');
        if (!image || !thumbs.length) return;
        let index = 0;
        const show = next => {
          index = Math.max(0,Math.min(thumbs.length-1,next));
          const thumb = thumbs[index];
          image.removeAttribute('srcset');
          image.src = thumb.dataset.fullUrl; image.alt = thumb.dataset.imageAlt;
          thumbs.forEach((button,i) => button.setAttribute('aria-current',String(i===index)));
          dialog.querySelector('.jools-gallery-prev').disabled = index===0;
          dialog.querySelector('.jools-gallery-next').disabled = index===thumbs.length-1;
          dialog.querySelector('[data-gallery-status]').textContent = (index+1)+' / '+thumbs.length;
          thumb.scrollIntoView({block:'nearest',inline:'nearest'});
        };
        document.addEventListener('click', e => {
          const trigger = e.target.closest('.jools-page-product .product__media-toggle');
          if (!trigger) return;
          const id = trigger.closest('[data-media-id]')?.dataset.mediaId.split('-').pop();
          const next = thumbs.findIndex(button => button.dataset.galleryId===id);
          if (next<0) return;
          e.preventDefault(); e.stopPropagation();
          this.openDialog(dialog,trigger); show(next);
        },{...opts,capture:true});
        thumbs.forEach((thumb,i) => thumb.addEventListener('click',()=>show(i),opts));
        dialog.querySelector('.jools-gallery-prev').addEventListener('click',()=>show(index-1),opts);
        dialog.querySelector('.jools-gallery-next').addEventListener('click',()=>show(index+1),opts);
        dialog.addEventListener('keydown',e=>{ if(e.key==='ArrowRight'){e.preventDefault();show(index+1);} if(e.key==='ArrowLeft'){e.preventDefault();show(index-1);} },opts);
        let startX;
        image.addEventListener('touchstart',e=>{startX=e.changedTouches[0].clientX;},{...opts,passive:true});
        image.addEventListener('touchend',e=>{const delta=e.changedTouches[0].clientX-startX;if(Math.abs(delta)>50)show(index+(delta<0?1:-1));},{...opts,passive:true});
        const setupDots = () => {
          const list = product.querySelector('.product__media-list');
          if (!list || list===this.galleryList) return;
          this.galleryList = list;
          list.parentElement.querySelector('.jools-gallery-dots')?.remove();
          const slides = Array.from(list.children).filter(slide => slide.matches('.product__media-item[data-media-id]'));
          if(slides.length<2)return;
          const dots = document.createElement('div'); dots.className='jools-gallery-dots';
          slides.forEach((slide,i)=>{const button=document.createElement('button'); button.type='button';button.setAttribute('aria-label',this.dataset.imageLabel.replace('__index__',String(i+1)));button.setAttribute('aria-controls',list.id);button.addEventListener('click',()=>list.scrollTo({left:slide.offsetLeft-list.offsetLeft,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'}),opts);dots.append(button);});
          list.parentElement.append(dots);
          const sync=()=>{let closest=0;let distance=Infinity;slides.forEach((slide,i)=>{const d=Math.abs(slide.getBoundingClientRect().left-list.getBoundingClientRect().left);if(d<distance){distance=d;closest=i;}});Array.from(dots.children).forEach((button,i)=>button.setAttribute('aria-current',String(i===closest)));};
          list.addEventListener('scroll',sync,{...opts,passive:true});sync();
        };
        this.galleryObserver=new MutationObserver(setupDots); this.galleryObserver.observe(product,{childList:true,subtree:true});setupDots();
      }
      bindCart() {
        const bubble = document.getElementById('cart-icon-bubble');
        if (!bubble) return;
        const sync = () => {
          const badge = this.querySelector('[data-jools-cart-count]');
          if (!badge) return;
          const countBubble = bubble.querySelector('.cart-count-bubble');
          const count = countBubble?.querySelector('span[aria-hidden="true"]')?.textContent.trim()
            || countBubble?.querySelector('.visually-hidden')?.textContent.match(/\d+/)?.[0] || '0';
          badge.textContent = count;
          badge.hidden = Number(count) === 0;
        };
        this.cartObserver = new MutationObserver(sync);
        this.cartObserver.observe(bubble, {childList:true,subtree:true,characterData:true});
        sync();
      }
      bindProduct(opts) {
        this.bar = this.querySelector('.jools-sticky-buy');
        const product = document.querySelector('product-info[id^="MainProduct-"]');
        if (!product || !this.bar) return;
        this.product = product;
        const proxy = this.bar.querySelector('[data-jools-add]');
        const update = () => {
          const button = product.querySelector('product-form button[name="add"]');
          const price = product.querySelector('[id^="price-"] .price:not(.price--on-sale) .price__regular .price-item--regular, [id^="price-"] .price--on-sale .price__sale .price-item--sale');
          this.bar.hidden = !button;
          if (!button) return;
          proxy.disabled = button.disabled || button.getAttribute('aria-disabled') === 'true';
          proxy.textContent = button.querySelector('span')?.textContent.trim() || button.textContent.trim();
          this.bar.querySelector('[data-jools-sticky-price]').textContent = price?.textContent.trim() || '';
          const error = product.querySelector('.product-form__error-message-wrapper:not([hidden])');
          if (error?.textContent.trim() && error.textContent !== this.lastError) { this.lastError = error.textContent; error.scrollIntoView({block:'center',behavior:'smooth'}); }
        };
        this.productObserver = new MutationObserver(update);
        this.productObserver.observe(product, {childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['disabled','aria-disabled','hidden','class']});
        proxy.addEventListener('click', () => {
          const button = product.querySelector('product-form button[name="add"]');
          if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
          const required = Array.from(button.form.querySelectorAll('[required]:not([disabled])')).find(field => !field.checkValidity());
          if (required) { required.scrollIntoView({block:'center'}); required.focus(); required.reportValidity(); return; }
          button.click();
        }, opts);
        this.bar.querySelector('.jools-options-link').addEventListener('click', () => {
          const target = product.querySelector('variant-selects') || product.querySelector('.product__info-container');
          target.scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
          const focus = target.querySelector('input:checked,select,button');
          focus?.focus({preventScroll:true});
        }, opts);

        update();
      }
      disconnectedCallback() {
        this.favAbort?.abort(); this.favObserver?.disconnect(); clearTimeout(this.favTimer); this.controller?.abort(); this.searchAbort?.abort(); this.productObserver?.disconnect(); this.cartObserver?.disconnect(); this.galleryObserver?.disconnect(); clearTimeout(this.timer);
        document.body.classList.remove('jools-dialog-open','jools-keyboard-open');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["magic-lamp"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (root.dataset.aiInitialized === 'true') return;
      root.dataset.aiInitialized = 'true';
      const endpoint = root.dataset.apiEndpoint;
      const accessEndpoint = root.dataset.accessEndpoint;
      const activityEndpoint = root.dataset.activityEndpoint;
      const form = root.querySelector('[data-magic-lamp-form]');
      const input = root.querySelector('[data-magic-lamp-input]');
      const inputRow = input.closest('.magic-lamp__input-row');
      const budget = root.querySelector('[data-magic-lamp-budget]');
      const type = root.querySelector('[data-magic-lamp-type]');
      const results = root.querySelector('[data-magic-lamp-results]');
      const introduction = root.querySelector('[data-magic-lamp-introduction]');
      const grid = root.querySelector('[data-magic-lamp-grid]');
      const more = root.querySelector('[data-magic-lamp-more]');
      const status = root.querySelector('[data-magic-lamp-status]');
      const submit = form.querySelector('[type="submit"]');
      const cardTemplate = root.querySelector('[data-magic-lamp-card-template]');
      const shownIds = new Set();
      const shownVendors = new Set();
      const activityIdsByProduct = new Map();
      const normalizeVendor = (value) => String(value || '').trim().toLocaleLowerCase();

      const chooseDiverseRecommendations = (recommendations, replace) => {
        const knownIds = replace ? new Set() : new Set(shownIds);
        const usedVendors = replace ? new Set() : new Set(shownVendors);
        const selected = [];
        const deferred = [];
        const seenCandidateIds = new Set();

        (Array.isArray(recommendations) ? recommendations : []).forEach((recommendation) => {
          const product = recommendation?.product;
          const productId = String(product?.id || '');
          if (!productId || knownIds.has(productId) || seenCandidateIds.has(productId)) return;
          seenCandidateIds.add(productId);

          const vendor = normalizeVendor(product.vendor);
          if (selected.length < 2 && vendor && !usedVendors.has(vendor)) {
            selected.push(recommendation);
            usedVendors.add(vendor);
          } else {
            deferred.push(recommendation);
          }
        });

        deferred.forEach((recommendation) => {
          if (selected.length >= 2) return;
          selected.push(recommendation);
        });

        return selected.slice(0, 2);
      };
      const accessTokenKey = 'jools-magic-lamp-access-token';
      let accessToken = localStorage.getItem(accessTokenKey) || '';
      let isAuthenticated = root.dataset.customerAuthenticated === 'true' || Boolean(accessToken);
      const authDialog = root.querySelector('[data-magic-lamp-auth]');
      const authBackdrop = root.querySelector('[data-magic-lamp-auth-backdrop]');
      const authForm = root.querySelector('[data-magic-lamp-auth-form]');
      const authSubmit = authForm?.querySelector('[type="submit"]');
      const authStatus = authForm?.querySelector('[data-magic-lamp-auth-status]');
      const voice = root.querySelector('[data-magic-lamp-voice]');
      const languageOptions = root.querySelectorAll('[data-magic-lamp-language-option]');
      let selectedLanguage = root.dataset.locale.startsWith('ar') ? 'ar-AE' : 'en-AE';
      let recognition;
      let authStartedAt = Date.now();
      const customerNameKey = 'jools-magic-lamp-customer-name';
      let customerName = root.dataset.customerName || localStorage.getItem(customerNameKey) || '';
      const sessionKey = 'jools-magic-lamp-session';
      let sessionId = sessionStorage.getItem(sessionKey);
      if (!sessionId) {
        sessionId = window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random()}`;
        sessionStorage.setItem(sessionKey, sessionId);
      }

      const setInputLanguage = (language) => {
        selectedLanguage = language;
        const isArabic = language === 'ar-AE';
        input.lang = isArabic ? 'ar' : 'en';
        input.dir = isArabic ? 'rtl' : 'ltr';
        inputRow.dir = input.dir;
        input.placeholder = isArabic ? input.dataset.placeholderAr : input.dataset.placeholderEn;
        voice.setAttribute('aria-label', isArabic ? voice.dataset.voiceLabelAr : voice.dataset.voiceLabelEn);
        if (recognition) recognition.lang = selectedLanguage;
        languageOptions.forEach((option) => {
          const active = option.dataset.magicLampLanguageOption === selectedLanguage;
          option.classList.toggle('is-active', active);
          option.setAttribute('aria-pressed', String(active));
        });
      };
      languageOptions.forEach((option) => {
        option.addEventListener('click', () => setInputLanguage(option.dataset.magicLampLanguageOption));
      });
      setInputLanguage(selectedLanguage);

      const formatMoney = (product) => {
        try {
          return new Intl.NumberFormat(root.dataset.locale, {
            style: 'currency',
            currency: product.currency || 'AED',
            maximumFractionDigits: 0
          }).format(Number(product.price || 0));
        } catch {
          return `${product.currency || 'AED'} ${Number(product.price || 0).toLocaleString()}`;
        }
      };

      const naturalizeCustomerText = (value) => String(value || '')
        .replace(/\bwell[\s\u2010-\u2015-]?being\b/gi, 'wellbeing')
        .replace(/([\p{L}])[-\u2010-\u2015\u2212](?=[\p{L}])/gu, '$1 ')
        .replace(/\s*[\u2010-\u2015\u2212]\s*/g, ', ')
        .replace(/\s+/g, ' ')
        .replace(/\s+([,.;:!?])/g, '$1')
        .trim();

      const renderRecommendations = (payload, replace) => {
        if (replace) {
          grid.innerHTML = '';
          activityIdsByProduct.clear();
        }
        introduction.textContent = naturalizeCustomerText(payload.introduction);
        const recommendations = chooseDiverseRecommendations(payload.recommendations, replace);
        recommendations.forEach((recommendation) => {
          const product = recommendation.product;
          if (!product || shownIds.has(String(product.id))) return;
          shownIds.add(String(product.id));
          const vendorKey = normalizeVendor(product.vendor);
          if (vendorKey) shownVendors.add(vendorKey);
          const card = cardTemplate.content.cloneNode(true);
          const activityId = recommendation.activityId || payload.activityId || '';
          if (activityId) activityIdsByProduct.set(String(product.id), activityId);
          card.querySelectorAll('[data-card-link]').forEach((link) => {
            link.href = product.url;
            link.dataset.magicLampProductId = String(product.id);
          });
          const image = card.querySelector('[data-card-image]');
          if (product.image) {
            image.src = product.image;
            image.alt = product.imageAlt || product.title;
          } else {
            image.hidden = true;
          }
          card.querySelector('[data-card-title]').textContent = product.title;
          card.querySelector('[data-card-vendor]').textContent = product.vendor;
          card.querySelector('[data-card-price]').textContent = formatMoney(product);
          card.querySelector('[data-card-reason]').textContent = naturalizeCustomerText(recommendation.reason);
          const badgeHost = card.querySelector('.magic-lamp__card');
          grid.appendChild(card);
          try {
            const badgeUrl = new URL(product.url, window.location.origin);
            if (badgeUrl.origin === window.location.origin && badgeUrl.pathname.includes('/products/')) {
              badgeUrl.searchParams.set('section_id', 'jools-mirdif-badge');
              fetch(badgeUrl.href, { credentials: 'same-origin' })
                .then((response) => response.ok ? response.text() : '')
                .then((html) => {
                  if (!html || !badgeHost.isConnected) return;
                  const badgeDocument = new DOMParser().parseFromString(html, 'text/html');
                  const badge = badgeDocument.querySelector('a.jools-try-on-badge');
                  if (badge) badgeHost.appendChild(badge);
                }).catch(() => {});
            }
          } catch (_) {}

        });
        results.hidden = shownIds.size === 0;
        more.hidden = !payload.hasMore;
      };

      const fetchRecommendationBatch = async ({ replace, excludedIds, excludedVendors, wish }) => {
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: { 'content-type': 'application/json' },
          body: JSON.stringify({
            wish,
            locale: selectedLanguage,
            maxBudget: Number(budget.value || 0),
            category: type.value,
            excludedIds: Array.from(excludedIds),
            excludedVendors: Array.from(excludedVendors),
            preferVendorDiversity: true,
            maxPerVendor: 1,
            recommendationCount: 12,
            sessionId,
            originalWish: input.value.trim(),
            customerName,
            accessToken
          })
        });
        const payload = await response.json();
        if (!response.ok) throw new Error(payload.error || root.dataset.errorMessage);
        return payload;
      };

      const requestRecommendations = async (replace = false) => {
        if (!isAuthenticated) {
          status.textContent = root.dataset.authRequiredMessage;
          openAuth();
          return;
        }
        if (!endpoint) {
          status.textContent = root.dataset.configurationMessage;
          return;
        }
        submit.disabled = true;
        more.disabled = true;
        status.textContent = root.dataset.loadingMessage;
        try {
          const baseExcludedIds = replace ? new Set() : new Set(shownIds);
          const baseExcludedVendors = replace ? new Set() : new Set(shownVendors);
          const originalWish = input.value.trim();
          const primaryPayload = await fetchRecommendationBatch({
            replace,
            excludedIds: baseExcludedIds,
            excludedVendors: baseExcludedVendors,
            wish: originalWish
          });

          const candidates = Array.isArray(primaryPayload.recommendations)
            ? primaryPayload.recommendations.map((recommendation) => ({
                ...recommendation,
                activityId: primaryPayload.activityId || ''
              }))
            : [];
          let selected = chooseDiverseRecommendations(candidates, replace);
          const selectedVendors = new Set(selected.map((item) => normalizeVendor(item?.product?.vendor)).filter(Boolean));

          if (selected.length < 2 || selectedVendors.size < 2) {
            const recoveryExcludedIds = new Set(baseExcludedIds);
            const recoveryExcludedVendors = new Set(baseExcludedVendors);
            candidates.forEach((item) => {
              const productId = String(item?.product?.id || '');
              const vendor = normalizeVendor(item?.product?.vendor);
              if (productId) recoveryExcludedIds.add(productId);
              if (vendor) recoveryExcludedVendors.add(vendor);
            });

            const vendorNames = candidates
              .map((item) => String(item?.product?.vendor || '').trim())
              .filter(Boolean)
              .filter((value, index, values) => values.indexOf(value) === index);
            const recoveryWish = vendorNames.length
              ? `${originalWish}\n\nCuration requirement: choose equally relevant products from different brands. Avoid repeating these brands: ${vendorNames.join(', ')}.`
              : originalWish;

            try {
              const recoveryPayload = await fetchRecommendationBatch({
                replace,
                excludedIds: recoveryExcludedIds,
                excludedVendors: recoveryExcludedVendors,
                wish: recoveryWish
              });
              if (Array.isArray(recoveryPayload.recommendations)) {
                candidates.push(...recoveryPayload.recommendations.map((recommendation) => ({
                  ...recommendation,
                  activityId: recoveryPayload.activityId || ''
                })));
              }
              primaryPayload.hasMore = Boolean(primaryPayload.hasMore || recoveryPayload.hasMore);
              selected = chooseDiverseRecommendations(candidates, replace);
            } catch {
              selected = chooseDiverseRecommendations(candidates, replace);
            }
          }

          primaryPayload.recommendations = selected;
          if (replace) {
            shownIds.clear();
            shownVendors.clear();
          }
          renderRecommendations(primaryPayload, replace);
          results.scrollIntoView({ behavior: 'smooth', block: 'start' });
          status.textContent = '';
        } catch (error) {
          status.textContent = error.message || root.dataset.errorMessage;
        } finally {
          submit.disabled = false;
          more.disabled = false;
        }
      };

      const openAuth = () => {
        if (!authDialog) return;
        authStartedAt = Date.now();
        authDialog.hidden = false;
        authBackdrop.hidden = false;
        document.body.classList.add('magic-lamp-auth-open');
        window.setTimeout(() => authDialog.querySelector('input')?.focus(), 0);
      };
      const closeAuth = () => {
        if (!authDialog) return;
        authDialog.hidden = true;
        authBackdrop.hidden = true;
        document.body.classList.remove('magic-lamp-auth-open');
      };

      if (!isAuthenticated && authDialog) {
        openAuth();
        authBackdrop.addEventListener('click', closeAuth);
        root.querySelector('[data-magic-lamp-auth-close]').addEventListener('click', closeAuth);
        authForm.addEventListener('submit', async (event) => {
          event.preventDefault();
          const data = new FormData(authForm);
          const name = String(data.get('name') || '').trim();
          const email = String(data.get('email') || '').trim();
          if (!name || !email || !authForm.reportValidity() || !accessEndpoint) return;
          if (authSubmit) {
            authSubmit.disabled = true;
            authSubmit.setAttribute('aria-busy', 'true');
          }
          if (authStatus) authStatus.textContent = '';
          try {
            const response = await fetch(accessEndpoint, {
              method: 'POST',
              headers: { 'content-type': 'application/json' },
              body: JSON.stringify({
                name,
                email,
                human: data.get('human') === 'true',
                website: String(data.get('website') || ''),
                locale: selectedLanguage,
                startedAt: authStartedAt
              })
            });
            const payload = await response.json();
            if (!response.ok || !payload.accessToken) {
              throw new Error(payload.error || root.dataset.errorMessage);
            }
            accessToken = payload.accessToken;
            customerName = payload.name || name;
            isAuthenticated = true;
            localStorage.setItem(accessTokenKey, accessToken);
            localStorage.setItem(customerNameKey, customerName);
            closeAuth();
            status.textContent = '';
          } catch (error) {
            if (authStatus) authStatus.textContent = error.message || root.dataset.errorMessage;
          } finally {
            if (authSubmit) {
              authSubmit.disabled = false;
              authSubmit.removeAttribute('aria-busy');
            }
          }
        });
      }

      form.addEventListener('submit', (event) => {
        event.preventDefault();
        if (!input.value.trim()) {
          status.textContent = root.dataset.emptyMessage;
          input.focus();
          return;
        }
        requestRecommendations(true);
      });
      more.addEventListener('click', () => requestRecommendations(false));
      grid.addEventListener('click', (event) => {
        const link = event.target.closest('[data-card-link]');
        const productId = link?.dataset.magicLampProductId || '';
        const activityId = activityIdsByProduct.get(productId) || '';
        if (!link || !productId || !activityId || !activityEndpoint) return;
        fetch(activityEndpoint, {
          method: 'POST',
          headers: { 'content-type': 'application/json' },
          body: JSON.stringify({
            action: 'product_click',
            activityId,
            productId,
            accessToken,
            customerName
          }),
          keepalive: true
        }).catch(() => {});
      });

      const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
      if (SpeechRecognition) {
        voice.hidden = false;
        recognition = new SpeechRecognition();
        recognition.lang = selectedLanguage;
        recognition.interimResults = false;
        voice.addEventListener('click', () => {
          recognition.lang = selectedLanguage;
          status.textContent = root.dataset.listeningMessage;
          voice.classList.add('is-listening');
          recognition.start();
        });
        recognition.addEventListener('result', (event) => {
          input.value = event.results[0][0].transcript;
        });
        recognition.addEventListener('end', () => {
          status.textContent = '';
          voice.classList.remove('is-listening');
        });
      }
    };

    document.querySelectorAll('.magic-lamp').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('.magic-lamp').forEach(initialize);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
